var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"minimal-information-edit"},[_c('InfosCampanhaFormEdit'),_c('DoseQuantificationCampaignEditForm',{on:{"priceRange":_vm.handlePriceRange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }